import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgDropbox = forwardRef((props, ref) => /* @__PURE__ */ jsxs(BaseIcon, { fill: "currentColor", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { d: "M12.013 6.175 7.006 9.369l5.007 3.194-5.007 3.193L2 12.545l5.006-3.193L2 6.175l5.006-3.194zM6.981 17.806l5.006-3.193 5.006 3.193L11.987 21z" }),
  /* @__PURE__ */ jsx("path", { d: "m12.013 12.545 5.006-3.194-5.006-3.176 4.98-3.194L22 6.175l-5.007 3.194L22 12.562l-5.007 3.194z" })
] }));

export { SvgDropbox as default };
//# sourceMappingURL=dropbox.mjs.map
